import { Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useContext } from "react";

import { SocketContext } from "../SocketContext";

const useStyles = makeStyles((theme) => ({
    video: {
        width: "400px",
        [theme.breakpoints.down("xs")]: {
            width: "300px",
        },
    },
    gridContainer: {
        justifyContent: "center",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
    },
    paper: {
        padding: "10px",
        border: "2px solid black",
        margin: "10px",
    },
}));

const VideoPlayer = () => {
    const { callAccepted, myVideo, userVideo, callEnded, stream, name, call } =
        useContext(SocketContext);
    const classes = useStyles();
    return (
        <Grid container className={classes.gridContainer}>
            {/*our video*/}
            {stream && (
                <Paper className={classes.paper}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>
                            {name || "name"}
                        </Typography>
                        <video muted playsInline autoPlay ref={myVideo} className={classes.video} />
                    </Grid>
                </Paper>
            )}
            {/*our video*/}
            {callAccepted && !callEnded && (
                <Paper className={classes.paper}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>
                            {call.name || "name"}
                        </Typography>
                        <video playsInline autoPlay ref={userVideo} className={classes.video} />
                    </Grid>
                </Paper>
            )}
        </Grid>
    );
};

export default VideoPlayer;
